module.exports = __webpack_public_path__ + "static/media/desktop-smartphone-screenshot.7b4c3efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/desktop-smartphone-screenshot.png
// module id = 712
// module chunks = 0